/// <amd-module name="VSS/Redux/Modules/Shortcuts/ShortcutsActions" />
import { createAction, ActionsUnion } from "redux/Utils/ActionHelper";
import { IReduxShortcutGroup } from "./ShortcutsContracts";

export const enum ShortcutsActionTypes {
    RegisterShortcutGroup = "Shortcuts/RegisterShortcutGroup",
    UnRegisterShortcutGroup = "Shortcuts/UnRegisterShortcutGroup"
}
export const ShortcutsActions = {
    registerShortcutGroup: (shortcutGroups: IReduxShortcutGroup[]) => createAction(ShortcutsActionTypes.RegisterShortcutGroup, { shortcutGroups }),
    unregisterShortcutGroup: (shortcutGroupNames: string[]) => createAction(ShortcutsActionTypes.UnRegisterShortcutGroup, { shortcutGroupNames })
};

export type ShortcutsActions = ActionsUnion<typeof ShortcutsActions>;
